export default __webpack_public_path__ + "static/media/android-s5.2eee23cb.webp";